import { useEffect } from "react";

export default function Landing() {
  useEffect(() => {
    document.title = "HireHero — Smarter Hiring";
  }, []);

  return (
    <div
      style={{
        fontFamily: "'DM Sans', sans-serif",
        background: "#0a0a0f",
        color: "#f0f0f0",
        minHeight: "100vh",
      }}
    >
      {/* Google Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:ital,wght@0,300;0,400;0,500;1,300&display=swap"
        rel="stylesheet"
      />
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        :root {
          --bg: #0a0a0f;
          --surface: #111118;
          --border: rgba(255,255,255,0.07);
          --accent: #c8f135;
          --text: #f0f0f0;
          --muted: #6b6b7a;
          --card: #14141e;
        }
        html { scroll-behavior: smooth; }
        body { background: #0a0a0f; }

        .nav {
          position: fixed; top: 0; left: 0; right: 0; z-index: 100;
          display: flex; align-items: center; justify-content: space-between;
          padding: 20px 60px;
          background: rgba(10,10,15,0.85);
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(255,255,255,0.07);
        }
        .logo {
          font-family: 'Syne', sans-serif; font-weight: 800;
          font-size: 1.4rem; letter-spacing: -0.03em;
        }
        .logo span { color: #c8f135; }
        .nav-links { display: flex; gap: 36px; list-style: none; }
        .nav-links a { color: #6b6b7a; text-decoration: none; font-size: 0.9rem; font-weight: 500; transition: color 0.2s; }
        .nav-links a:hover { color: #f0f0f0; }
        .nav-cta {
          background: #c8f135 !important; color: #0a0a0f !important;
          padding: 9px 22px; border-radius: 8px; font-weight: 600 !important;
        }

        .hero {
          min-height: 100vh; display: flex; align-items: center; justify-content: center;
          padding: 120px 60px 80px; position: relative; overflow: hidden; text-align: center;
        }
        .hero-bg {
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 60% 50% at 50% 0%, rgba(200,241,53,0.08) 0%, transparent 70%),
            radial-gradient(ellipse 40% 40% at 80% 60%, rgba(59,130,246,0.06) 0%, transparent 60%);
        }
        .hero-grid {
          position: absolute; inset: 0;
          background-image: linear-gradient(rgba(255,255,255,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.07) 1px, transparent 1px);
          background-size: 60px 60px;
          mask-image: radial-gradient(ellipse 80% 60% at 50% 0%, black 0%, transparent 80%);
        }
        .hero-content { max-width: 860px; position: relative; z-index: 1; }
        .hero-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(200,241,53,0.1); border: 1px solid rgba(200,241,53,0.2);
          color: #c8f135; padding: 6px 16px; border-radius: 100px;
          font-size: 0.8rem; font-weight: 600; letter-spacing: 0.05em;
          text-transform: uppercase; margin-bottom: 32px;
        }
        .badge-dot {
          width: 6px; height: 6px; background: #c8f135; border-radius: 50%;
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(0.8); }
        }
        .hero h1 {
          font-family: 'Syne', sans-serif;
          font-size: clamp(3rem, 7vw, 5.5rem);
          font-weight: 800; line-height: 1.05; letter-spacing: -0.04em; margin-bottom: 24px;
        }
        .hero h1 .accent { color: #c8f135; }
        .hero h1 .dim { color: #6b6b7a; }
        .hero-sub {
          font-size: 1.15rem; color: #6b6b7a; max-width: 520px;
          margin: 0 auto 48px; font-weight: 300; line-height: 1.7;
        }
        .hero-actions { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
        .btn-primary {
          background: #c8f135; color: #0a0a0f; padding: 14px 32px; border-radius: 10px;
          font-weight: 700; font-size: 0.95rem; text-decoration: none;
          transition: transform 0.2s, box-shadow 0.2s;
          box-shadow: 0 0 40px rgba(200,241,53,0.2);
          display: inline-block;
        }
        .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 0 60px rgba(200,241,53,0.35); }
        .btn-secondary {
          background: transparent; color: #f0f0f0; padding: 14px 32px; border-radius: 10px;
          font-weight: 500; font-size: 0.95rem; text-decoration: none;
          border: 1px solid rgba(255,255,255,0.07); transition: border-color 0.2s, background 0.2s;
          display: inline-block;
        }
        .btn-secondary:hover { border-color: rgba(255,255,255,0.2); background: rgba(255,255,255,0.03); }

        .stats {
          display: flex; justify-content: center; gap: 60px;
          padding: 60px; flex-wrap: wrap;
          border-top: 1px solid rgba(255,255,255,0.07);
          border-bottom: 1px solid rgba(255,255,255,0.07);
        }
        .stat-item { text-align: center; }
        .stat-number {
          font-family: 'Syne', sans-serif; font-size: 2.8rem; font-weight: 800;
          color: #c8f135; letter-spacing: -0.04em; line-height: 1;
        }
        .stat-label { font-size: 0.85rem; color: #6b6b7a; margin-top: 6px; }

        .section { padding: 100px 60px; max-width: 1200px; margin: 0 auto; }
        .section-tag {
          font-size: 0.75rem; font-weight: 700; letter-spacing: 0.12em;
          text-transform: uppercase; color: #c8f135; margin-bottom: 16px;
        }
        .section-title {
          font-family: 'Syne', sans-serif;
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 800; letter-spacing: -0.03em; line-height: 1.1; margin-bottom: 60px;
        }
        .section-title .muted { color: #6b6b7a; }

        .steps {
          display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 2px; background: rgba(255,255,255,0.07);
          border: 1px solid rgba(255,255,255,0.07); border-radius: 16px; overflow: hidden;
        }
        .step { background: #14141e; padding: 40px; transition: background 0.3s; }
        .step:hover { background: #1a1a28; }
        .step-num {
          font-family: 'Syne', sans-serif; font-size: 3.5rem; font-weight: 800;
          color: rgba(200,241,53,0.12); line-height: 1; margin-bottom: 20px; letter-spacing: -0.05em;
        }
        .step h3 { font-family: 'Syne', sans-serif; font-size: 1.1rem; font-weight: 700; margin-bottom: 10px; }
        .step p { font-size: 0.9rem; color: #6b6b7a; line-height: 1.6; }

        .score-demo {
          background: #14141e; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 20px; padding: 48px; margin-top: 80px;
        }
        .score-demo-title { font-family: 'Syne', sans-serif; font-size: 1.3rem; font-weight: 700; margin-bottom: 32px; }
        .score-rows { display: flex; flex-direction: column; gap: 16px; }
        .score-row { display: flex; align-items: center; gap: 16px; }
        .score-name { width: 140px; font-size: 0.85rem; color: #6b6b7a; flex-shrink: 0; }
        .score-bar-wrap { flex: 1; height: 8px; background: rgba(255,255,255,0.05); border-radius: 100px; overflow: hidden; }
        .score-bar { height: 100%; border-radius: 100px; }
        .score-bar.green { background: #c8f135; }
        .score-bar.yellow { background: #f59e0b; }
        .score-bar.red { background: #ef4444; }
        .score-val { width: 50px; text-align: right; font-family: 'Syne', sans-serif; font-weight: 700; font-size: 0.9rem; }
        .score-status { width: 100px; text-align: right; font-size: 0.75rem; font-weight: 600; padding: 3px 10px; border-radius: 100px; }
        .status-invite { background: rgba(200,241,53,0.1); color: #c8f135; }
        .status-manual { background: rgba(245,158,11,0.1); color: #f59e0b; }
        .status-reject { background: rgba(239,68,68,0.1); color: #ef4444; }

        .features-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; }
        .feature-card {
          background: #14141e; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 16px; padding: 36px; transition: border-color 0.3s, transform 0.3s;
        }
        .feature-card:hover { border-color: rgba(200,241,53,0.2); transform: translateY(-4px); }
        .feature-icon {
          width: 48px; height: 48px; background: rgba(200,241,53,0.1);
          border-radius: 12px; display: flex; align-items: center; justify-content: center;
          font-size: 1.4rem; margin-bottom: 20px;
        }
        .feature-card h3 { font-family: 'Syne', sans-serif; font-size: 1rem; font-weight: 700; margin-bottom: 10px; }
        .feature-card p { font-size: 0.875rem; color: #6b6b7a; line-height: 1.65; }

        .pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 24px; }
        .pricing-card {
          background: #14141e; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 20px; padding: 40px; position: relative;
        }
        .pricing-card.featured {
          border-color: rgba(200,241,53,0.3);
          background: linear-gradient(135deg, #14141e, #1a1f14);
        }
        .pricing-badge {
          position: absolute; top: -12px; left: 50%; transform: translateX(-50%);
          background: #c8f135; color: #0a0a0f; font-size: 0.7rem; font-weight: 700;
          letter-spacing: 0.08em; text-transform: uppercase;
          padding: 4px 16px; border-radius: 100px;
        }
        .pricing-name { font-family: 'Syne', sans-serif; font-size: 1rem; font-weight: 700; color: #6b6b7a; margin-bottom: 16px; }
        .pricing-price { font-family: 'Syne', sans-serif; font-size: 3rem; font-weight: 800; letter-spacing: -0.04em; line-height: 1; margin-bottom: 8px; }
        .pricing-price span { font-size: 1rem; font-weight: 400; color: #6b6b7a; }
        .pricing-desc { font-size: 0.85rem; color: #6b6b7a; margin-bottom: 32px; }
        .pricing-features { list-style: none; display: flex; flex-direction: column; gap: 12px; margin-bottom: 36px; }
        .pricing-features li { display: flex; align-items: center; gap: 10px; font-size: 0.875rem; color: #6b6b7a; }
        .pricing-features li::before { content: '✓'; color: #c8f135; font-weight: 700; flex-shrink: 0; }
        .btn-pricing { display: block; text-align: center; padding: 13px; border-radius: 10px; font-weight: 600; font-size: 0.9rem; text-decoration: none; transition: all 0.2s; }
        .btn-pricing-outline { border: 1px solid rgba(255,255,255,0.07); color: #f0f0f0; }
        .btn-pricing-outline:hover { border-color: rgba(255,255,255,0.2); background: rgba(255,255,255,0.03); }
        .btn-pricing-filled { background: #c8f135; color: #0a0a0f; }
        .btn-pricing-filled:hover { opacity: 0.88; }

        .contact-wrap {
          background: #14141e; border: 1px solid rgba(255,255,255,0.07);
          border-radius: 24px; padding: 64px;
          display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: start;
        }
        .contact-left h2 {
          font-family: 'Syne', sans-serif; font-size: 2.2rem; font-weight: 800;
          letter-spacing: -0.03em; margin-bottom: 16px; line-height: 1.15;
        }
        .contact-left p { color: #6b6b7a; font-size: 0.95rem; line-height: 1.7; }
        .form-group { margin-bottom: 20px; }
        .form-group label { display: block; font-size: 0.8rem; font-weight: 600; color: #6b6b7a; margin-bottom: 8px; letter-spacing: 0.03em; }
        .form-group input, .form-group textarea {
          width: 100%; background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.07); border-radius: 10px;
          padding: 12px 16px; color: #f0f0f0;
          font-family: 'DM Sans', sans-serif; font-size: 0.9rem; outline: none; transition: border-color 0.2s;
        }
        .form-group input:focus, .form-group textarea:focus { border-color: rgba(200,241,53,0.4); }
        .form-group textarea { height: 120px; resize: none; }

        footer {
          border-top: 1px solid rgba(255,255,255,0.07); padding: 40px 60px;
          display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px;
        }
        footer p { font-size: 0.8rem; color: #6b6b7a; }
        .footer-links { display: flex; gap: 24px; list-style: none; }
        .footer-links a { color: #6b6b7a; text-decoration: none; font-size: 0.8rem; transition: color 0.2s; }
        .footer-links a:hover { color: #f0f0f0; }

        @media (max-width: 768px) {
          .nav { padding: 16px 24px; }
          .nav-links { display: none; }
          .hero { padding: 100px 24px 60px; }
          .stats { padding: 40px 24px; gap: 32px; }
          .section { padding: 60px 24px; }
          .contact-wrap { grid-template-columns: 1fr; padding: 40px 24px; gap: 40px; }
          footer { padding: 32px 24px; flex-direction: column; text-align: center; }
        }
      `}</style>
      {/* NAV */}d
      <nav className="nav">
        <div className="logo">
          Hire<span className={"accent"}>Hero</span>.
        </div>
        <ul className="nav-links">
          <li>
            <a href="#how">Wie es funktioniert</a>
          </li>
          <li>
            <a href="#features">Features</a>
          </li>
          <li>
            <a href="#pricing">Preise</a>
          </li>
          <li>
            <a href="#contact" className="nav-cta">
              Kontakt
            </a>
          </li>
        </ul>
      </nav>
      {/* HERO */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="hero-grid"></div>
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            Jetzt verfügbar
          </div>
          <h1>
            Bewerbungs
            <br />
            <span className="accent">Prozess</span>
            <br />
            <span className="dim">automatisiert.</span>
          </h1>
          <p className="hero-sub">
            HireHero analysiert eingehende Bewerbungen mit KI, vergibt einen
            Score und entscheidet automatisch — damit dein Team sich auf die
            wirklich guten Kandidaten konzentriert.
          </p>
          <div className="hero-actions">
            <a href="#how" className="btn-secondary">
              Wie funktioniert es?
            </a>
          </div>
        </div>
      </section>
      {/* STATS */}
      <div className="stats">
        {[
          { num: "90%", label: "weniger manuelle Prüfungen" },
          { num: "100%", label: "DSGVO-konform" },
          { num: "24/7", label: "automatische Verarbeitung" },
        ].map((s) => (
          <div className="stat-item" key={s.num}>
            <div className="stat-number">{s.num}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
      {/* HOW IT WORKS */}
      <section className="section" id="how">
        <div className="section-tag">Ablauf</div>
        <div className="section-title">
          In 4 Schritten
          <br />
          <span className="muted">zum perfekten Kandidaten</span>
        </div>
        <div className="steps">
          {[
            {
              n: "01",
              title: "Kriterien definieren",
              desc: "Du legst fest wonach die KI suchen soll — Keywords, Anforderungen, Gewichtungen.",
            },
            {
              n: "02",
              title: "Bewerbung eingeht",
              desc: "Bewerber schickt seinen Lebenslauf an eure dedizierte Email-Adresse.",
            },
            {
              n: "03",
              title: "KI bewertet",
              desc: "HireHero analysiert den CV innerhalb von Sekunden und vergibt einen Score von 0–100.",
            },
            {
              n: "04",
              title: "Automatische Aktion",
              desc: "Absage, manuelle Prüfung oder Einladung — alles passiert automatisch.",
            },
          ].map((s) => (
            <div className="step" key={s.n}>
              <div className="step-num">{s.n}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>
      {/* FEATURES */}
      <section className="section" id="features">
        <div className="section-tag">Features</div>
        <div className="section-title">
          Alles was du
          <br />
          <span className="muted">brauchst</span>
        </div>
        <div className="features-grid">
          {[
            {
              icon: "🎯",
              title: "Individuelle Kriterien",
              desc: "Jede Stelle hat eigene Keywords, Gewichtungen und Score-Schwellen — vollständig anpassbar.",
            },
            {
              icon: "⚡",
              title: "Automatische Antworten",
              desc: "Absagen und Einladungen werden automatisch versendet.",
            },
            {
              icon: "👁",
              title: "Transparente Begründung",
              desc: "Jede KI-Entscheidung wird begründet — damit dein Team nachvollziehen kann warum.",
            },
            {
              icon: "🔒",
              title: "DSGVO-konform",
              desc: "Alle Daten werden auf EU-Servern gespeichert. AVV inklusive.",
            },
            {
              icon: "📊",
              title: "Dashboard",
              desc: "Übersicht aller Bewerbungen, Scores und Status auf einen Blick.",
            },
            {
              icon: "✉️",
              title: "Eigene Email-Adresse",
              desc: "Jede Firma bekommt eine dedizierte Bewerber-Email — kein Setup bei eurer IT nötig.",
            },
          ].map((f) => (
            <div className="feature-card" key={f.title}>
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
      {/* PRICING */}
      <section className="section" id="pricing">
        <div className="section-tag">Preise</div>
        <div className="section-title">
          Einfach.
          <br />
          <span className="muted">Transparent.</span>
        </div>
        <div className="pricing-grid">
          <div className="pricing-card">
            <div className="pricing-name">Starter</div>
            <div className="pricing-price">
              €59<span>/Monat</span>
            </div>
            <div className="pricing-desc">Für kleine Unternehmen</div>
            <ul className="pricing-features">
              <li>Bis zu 50 Bewerbungen/Monat</li>
              <li>Automatische Emails</li>
              <li>Dashboard</li>
              <li>KI-Begründungen</li>
            </ul>
            <a href="#contact" className="btn-pricing btn-pricing-outline">
              Anfragen
            </a>
          </div>
          <div className="pricing-card featured">
            <div className="pricing-badge">Beliebt</div>
            <div className="pricing-name">Professional</div>
            <div className="pricing-price">
              €149<span>/Monat</span>
            </div>
            <div className="pricing-desc">Für wachsende Teams</div>
            <ul className="pricing-features">
              <li>Bis zu 150 Bewerbungen/Monat</li>
              <li>Automatische Emails</li>
              <li>Dashboard</li>
              <li>KI-Begründungen</li>
            </ul>
            <a href="#contact" className="btn-pricing btn-pricing-filled">
              Anfragen
            </a>
          </div>
          <div className="pricing-card">
            <div className="pricing-name">Enterprise</div>
            <div className="pricing-price">
              Auf<span> Anfrage</span>
            </div>
            <div className="pricing-desc">Nichts für Sie dabei?</div>
            <ul className="pricing-features">
              <li>Unbegrenzte Bewerbungen/Monat</li>
              <li>Automatische Emails</li>
              <li>Dashboard</li>
              <li>KI-Begründungen</li>
            </ul>
            <a href="#contact" className="btn-pricing btn-pricing-outline">
              Kontakt aufnehmen
            </a>
          </div>
        </div>
      </section>
      {/* CONTACT */}
      <section className="section" id="contact">
        <div className="contact-wrap">
          <div className="contact-left">
            <h2>
              Interesse?
              <br />
              Melden Sie sich.
            </h2>
            <p>
              Wir richten alles für Sie ein — kein technischer Aufwand auf
              deiner Seite. Schreib uns kurz und wir melden uns innerhalb von 24
              Stunden.
            </p>
          </div>
          <div className="contact-right">
            <div className="form-group">
              <label>Dein Name</label>
              <input type="text" placeholder="Max Mustermann" />
            </div>
            <div className="form-group">
              <label>Firmenname</label>
              <input type="text" placeholder="Musterfirma GmbH" />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" placeholder="max@musterfirma.com" />
            </div>
            <div className="form-group">
              <label>Nachricht (optional)</label>
              <textarea placeholder="Kurze Beschreibung eurer Situation..."></textarea>
            </div>
            <a
              className="btn-primary"
              style={{ display: "block", textAlign: "center" }}
            >
              Nachricht senden
            </a>
          </div>
        </div>
      </section>
      {/* FOOTER */}
      <footer>
        <div className="logo">
          HireHero<span>.</span>
        </div>
        <p>© 2026 XY. Alle Rechte vorbehalten.</p>
        <ul className="footer-links">
          <li>
            <a>Impressum</a>
          </li>
          <li>
            <a>Datenschutz</a>
          </li>
        </ul>
      </footer>
    </div>
  );
}
